import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a6db0bd81b1030014a7e704_1786539140567_b5c3d443/prizma/src/app/not-found.tsx");
